export const appointmentData = [
    
  ]
  
  export const doctorData = [
    {
      id: 1,
      name: "Aladdin",
      dep: "Fantasy/Musical",
      img: "./img/aladdin.jpg",
    },
    {
      id: 2,
      name: "Harry Potter",
      dep: "Fantasy/Adventure",
      img: "./img/harry.jpg",
    },
    {
      id: 3,
      name: "avengers EndGame",
      dep: "Action/Sci-fi",
      img: "./img/avenger.jpg",
    },
    {
      id: 4,
      name: "Guardians of the Galaxy",
      dep: "Action/Sci-fi",
      img: "./img/guardian.jpg",
    },
    {
      id: 5,
      name: "Pathan",
      dep: "Action/Thriller",
      img: "./img/pathan.jpg",
    },
    {
      id: 6,
      name: "Jailer",
      dep: "Action/Thriller",
      img: "./img/jailer.jpg",
    },
    {
      id: 7,
      name: "K.G.F",
      dep: "Action/Crime",
      img: "./img/kgf.jpg",
    },
    {
      id: 8,
      name: "Bahubali",
      dep: "Action/Fantasy",
      img: "./img/bahubali.jpg",
    },
  ]